import { trpc } from "../trpc";

/**
 * Apply a user-chosen app connection (`authenticationId`) onto assets that were
 * just copied into the current account. Backs the "Connect your apps" modal:
 * after the user picks/creates a connection per app, the modal calls this to
 * set the connection on the matching steps of the copied assets. The response
 * re-derives which apps still need connecting.
 */
export function useWireConnections() {
  const mutation = trpc.zsl.wireConnections.useMutation();

  return {
    wireConnections: mutation.mutateAsync,
    isWiring: mutation.isPending,
    error: mutation.error,
  };
}
